import { render, staticRenderFns } from "./liveEvents.vue?vue&type=template&id=18460d66&scoped=true&"
import script from "./liveEvents.vue?vue&type=script&lang=js&"
export * from "./liveEvents.vue?vue&type=script&lang=js&"
import style0 from "./liveEvents.vue?vue&type=style&index=0&id=18460d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18460d66",
  null
  
)

export default component.exports